// extracted by mini-css-extract-plugin
export default {"cls1":"SearchBar-cls1___af951daf7314fc2263d","cls2":"SearchBar-cls2__ca507b5371ffc77f9fda SearchBar-cls1___af951daf7314fc2263d"};